import { Module } from "@/constants";
import { Permission } from "@/types/permission";
import { Permissions } from "@/types/permissions";
import { useMemo } from "react";
import useAccount from "./useAccount";
import { mergeModulePermissions } from "../utils/mergeModulePermissions";

const defaultPermissions: Permission[] = [];

const permissionsCache = new Map<string, Permissions>();

export const usePermissions = (): Permissions => {
  const { account } = useAccount();
  const permissions = account?.permissions || defaultPermissions;

  const permissionsObject = useMemo(() => {
    if (!account) {
      return {} as Permissions;
    }

    const cachedPermissions = permissionsCache.get(account.id);
    if (cachedPermissions) {
      return cachedPermissions;
    }

    const computed = Object.fromEntries(
      Object.values(Module).map((module) => [
        module,
        mergeModulePermissions(module as Module, permissions),
      ]),
    ) as unknown as Permissions;

    permissionsCache.set(account.id, computed);
    return computed;
  }, [permissions, account]);

  return permissionsObject;
};
